import { useCountryConfig } from '~/composables/useCountryConfig'

export function useHeaderInformation() {
  const route = useRoute()
  const config = useCountryConfig()
  const { t } = useNuxtApp().$i18n
  const title = computed(() => t(config.titleTranslationKey, { title: t(route.meta.title as string ?? '') }))
  const description = computed(() => t('layout.description'))
  return {
    ogImage: config.ogImage,
    favicon: config.favicon,
    title,
    description,
  }
}
